<template>
    <!-- Barra de acessibilidade do site público: cada atalho pode ser ligado/desligado em Configurações >
         Opções do site. O tamanho do texto fica na faixa amarela do Header.vue (ControlesTamanhoTexto.vue).
         data-contraste: as regras do alto contraste (app.css) só valem com o botão Contraste habilitado. -->
    <div id="barra-acessibilidade" class="barra text-white print:hidden" role="region" aria-label="Acessibilidade e atalhos"
        :data-contraste="ligado('barra_contraste') ? '' : undefined">
        <div class="container mx-auto h-full px-2 sm:px-3 flex items-center justify-between gap-2">
            <ul class="flex items-center gap-1 sm:gap-2 h-full overflow-x-auto no-scrollbar">
                <li v-if="ligado('barra_mais_transparencia')" class="flex-shrink-0">
                    <Link :href="route('transparencia.public')" class="item" title="Mais Transparência">
                        <Eye class="w-4 h-4" aria-hidden="true" />
                        <span class="hidden sm:inline">Mais Transparência</span>
                        <span class="sm:hidden sr-only">Mais Transparência</span>
                    </Link>
                </li>

                <template v-if="ligado('barra_contraste')">
                    <li v-if="temAntes('barra_contraste')" class="separador" aria-hidden="true"></li>
                    <li class="flex-shrink-0">
                        <button type="button" class="item" :class="{ 'item-ativo': contrasteAtivo }" :aria-pressed="contrasteAtivo" title="Alto contraste" @click="alternarContraste">
                            <Contrast class="w-4 h-4" aria-hidden="true" />
                            <span class="hidden sm:inline">Contraste</span>
                            <span class="sm:hidden sr-only">Alto contraste</span>
                        </button>
                    </li>
                </template>

                <template v-if="ligado('barra_mapa_site')">
                    <li v-if="temAntes('barra_mapa_site')" class="separador" aria-hidden="true"></li>
                    <li class="flex-shrink-0">
                        <!-- Sem JavaScript, o link leva à página completa do mapa. -->
                        <a :href="route('mapa-do-site.public')" class="item" aria-haspopup="dialog" :aria-expanded="mapaAberto" title="Mapa do Site" @click.prevent="mapaAberto = true">
                            <MapIcon class="w-4 h-4" aria-hidden="true" />
                            <span class="hidden sm:inline">Mapa do Site</span>
                            <span class="sm:hidden sr-only">Mapa do Site</span>
                        </a>
                    </li>
                </template>
            </ul>

            <a v-if="ligado('barra_area_servidor')" :href="route('login')" class="item flex-shrink-0" title="Área do servidor">
                <LockKeyhole class="w-4 h-4" aria-hidden="true" />
                <span class="hidden sm:inline">Área do servidor</span>
                <span class="sm:hidden sr-only">Área do servidor</span>
            </a>
        </div>

        <MapaDoSiteDrawer v-if="ligado('barra_mapa_site')" :aberto="mapaAberto" @fechar="mapaAberto = false" />
    </div>
</template>

<script setup>
import { ref } from 'vue'
import { Link, usePage } from '@inertiajs/vue3'
import { Contrast, Eye, LockKeyhole, Map as MapIcon } from 'lucide-vue-next'
import MapaDoSiteDrawer from '@/Components/Welcom/MapaDoSiteDrawer.vue'
import { useAltoContraste } from '@/Composables/useAltoContraste'
import { opcaoLigada } from '@/Utils/configuracaoSite'

const { ativo: contrasteAtivo, alternar: alternarContraste } = useAltoContraste()

const mapaAberto = ref(false)

const page = usePage()
const ligado = (chave) => opcaoLigada(page.props.configuracaoSite, chave)

// Separador só entre atalhos visíveis do grupo da esquerda (Área do servidor fica à direita).
const ATALHOS_DA_ESQUERDA = ['barra_mais_transparencia', 'barra_contraste', 'barra_mapa_site']
const temAntes = (chave) => ATALHOS_DA_ESQUERDA.slice(0, ATALHOS_DA_ESQUERDA.indexOf(chave)).some(ligado)
</script>

<style scoped>
.barra {
    height: var(--altura-barra-acessibilidade);
    @apply bg-admin-primary;
}
.item {
    @apply inline-flex items-center gap-1.5 h-8 px-2 rounded-md text-xs sm:text-sm font-semibold whitespace-nowrap text-white hover:bg-white/15 focus:outline-none focus-visible:ring-2 focus-visible:ring-white transition-colors;
}
.item-ativo {
    @apply bg-white text-admin-primary hover:bg-white;
}
.separador {
    @apply hidden sm:block w-px h-4 bg-white/30 flex-shrink-0;
}
.no-scrollbar {
    scrollbar-width: none;
}
.no-scrollbar::-webkit-scrollbar {
    display: none;
}
</style>
